import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";
const borderColor = '#F5F5F5'
const styles = StyleSheet.create({
  headerContainer: {

    padding: 12,
    borderColor: borderColor, // gray-300
    borderWidth: 1,
    // marginBottom: 5,
  },
  billTo: {
    color: '#333',  // Darker text for better contrast
    fontSize: 9,    // Slightly larger for readability
    lineHeight: 1.5,  // More spacing for clarity
    marginBottom: 5,  // Adds spacing between multiple lines
  },
  cancellationpolicy: {
    // color: '#555',  
    fontSize: 9,    // Adjusted for a more subtle appearance
    lineHeight: 1.4,
    marginBottom: 3,  // Slight margin between cancellation details
  },
});


  let getDateModal = (data, selectedDate) => {
    let DataNew = "";
    const selectActivityDay = selectedDate;

    if (data[0].cancellation_penalty_id == 1) {
      const date = new Date(selectActivityDay);
      DataNew =
        "Free Cancellation (100% refund) if you cancel this booking on or before start of experience (tour, event, attraction, activity). ";
    } else if (data[0].cancellation_penalty_id == 3) {
      DataNew =
        "Minimum " +
        data[0].cancellation_value +
        "% cancellation charges applicable";
    }
    return DataNew;
  };

  let CancellationModal = (data, selectedDate) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    let ContentData = "";
    return (
      <Text>
        {" "}
        {data
          .slice(0)
          .reverse()
          .map((i, index) => {
            //const date = new Date();
            const selectActivityDay = selectedDate;
            const date = new Date(selectActivityDay);
            if (i.day_before_arrival == 1 || i.day_before_arrival == 2) {
              date.setDate(date.getDate() - i.day_before_arrival);
              DataNew = moment(date).format("Do MMM YYYY");
            }
            {
              date.setDate(date.getDate() - (i.day_before_arrival - 2));
              // DataNew = moment(date).format("Do MMM YYYY");
              DataNew =
                "If cancelled or modified " +
                parseInt(i.day_before_arrival - 2) +
                " days before date of experience (tour, event, attraction, activity). ";
            }

            if (i.penalty == "No Penalty") {
              Value = 0;
              EuroIcon = "";
              PerIcon = "";
            } else if (i.penalty == "Full Amount") {
              Value = "";
              EuroIcon = "";
              PerIcon = " Full booking amount will be charged. ";
            } else if (i.penalty == "Percentage") {
              Value = i.cancellation_value;
              EuroIcon = "";
              PerIcon = "% of booking amount will be charged. ";
            } else if (i.penalty == "Nights") {
              Value = i.cancellation_value;
              EuroIcon = EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged. ";
            } else if (i.penalty == "Fixed Amount") {
              Value = i.cancellation_value;
              EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged. ";
            }

            if (i.day_before_arrival == 1) {
              DataNew = " In case of no show ";
              //ContentData = "In case of "
            }

            //   if (id == i.rate_plan_id) {
            return (
              <Text>
                <Text style={styles.cancellationpolicy}>
                  {index == 0 ? "" : ""} &#x202A;{DataNew}&#x202C;
                </Text>
                <Text style={styles.cancellationpolicy}>
                  {EuroIcon} {Value}
                  {PerIcon}
                </Text>
              </Text>
            );
            
          })}
      </Text>
    );
  };

  const CancellationExperience = ({invoice}) => {

    var selectedDate = invoice.tour_booking_date;
    var items1 =  (JSON.stringify(invoice?.cancellation_policy));
    var items2 = JSON.parse(items1);
    var items3 = JSON.parse(items2);
   const rowsCancel =  items3&&(items3?.cancellation_policy.map(item =>{
   return item[0].cancellation_penalty_id == 1 ?(<Text style={styles.billTo}>{getDateModal(item, selectedDate)} <br/></Text>):(<Text style={styles.billTo}>{CancellationModal(item, selectedDate)} <br/></Text>)
   }
   ))
   return (<View style={styles.headerContainer}><Text style={{
    fontSize: 10,
    // lineHeight: 1.5,
    marginBottom: 8,
    
   }}>Cancellation Policy: </Text>{rowsCancel}</View>)
  }

  export default CancellationExperience